import { useState } from "react";
import EmailUtils from "../../../shared/utils/EmailUtils";
import PhoneUtils from "../../../shared/utils/PhoneUtils";
import {
	formatApplicationPayload,
} from "../utils/simulacao-utils";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import { hasValidationErrors } from "../../utils/validation-utils";

const getNameParts = value => {
	return String(value || "")
		.trim()
		.split(/\s+/)
		.filter(Boolean);
};

const validateApplicationData = ({
	completeName,
	emails,
	telephone,
	celphone
} = {}) => {
	const errors = {};
	const nameParts = getNameParts(completeName);
	const emailList = Array.isArray(emails) ? emails : [];

	const invalidEmails = emailList.filter(email => {
		return !EmailUtils.isValidEmail(email);
	});

	if (nameParts.length < 2) {
		errors.completeName = "Informe nome e sobrenome.";
	}

	if (emailList.length === 0) {
		errors.emails = "Informe ao menos um e-mail.";
	}

	if (invalidEmails.length > 0) {
		errors.emails = "Verifique os e-mails inválidos.";
		errors.emailsInvalidItems = invalidEmails;
	}

	if (telephone && !PhoneUtils.isValidTelephone(telephone)) {
		errors.telephone = "Informe um telefone válido.";
	}

	if (!celphone) {
		errors.celphone = "Informe o celular.";
	} else if (!PhoneUtils.isValidCellphone(celphone)) {
		errors.celphone = "Informe um celular válido.";
	}

	return errors;
};

export function useSubmitApplication() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [validationErrors, setValidationErrors] = useState({});

	async function submitApplication(simulationId, payloadData) {
		try {
			setLoading(true);
			setError(null);
			setValidationErrors({});

			const errors = validateApplicationData(payloadData);

			if (hasValidationErrors(errors)) {
				setValidationErrors(errors);

				return {
					ok: false,
					validationErrors: errors
				};
			}

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const body = formatApplicationPayload(payloadData);

			const requestOptions = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				},
				body: JSON.stringify(body)
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-simulador/v1/simulacoes/${encodeURIComponent(simulationId)}/enviar-proposta`,
				requestOptions
			);

			const data = await response.json().catch(() => null);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível enviar a proposta."
				);
			}

			return {
				ok: true,
				message: data?.mensagem || "Proposta enviada com sucesso.",
				protocol: data?.protocoloEnvio || "",
				application: data
			};
		} catch (requestError) {
			setError(requestError.message);

			return {
				ok: false,
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		loading,
		error,
		validationErrors,
		submitApplication
	};
}